






import { Component, Vue } from 'vue-property-decorator';
import API from '@/Api';

@Component
export default class UpcomingHoliday extends Vue {
    public date: string = '';
    public occasion: string = '';

    public mounted() {
        API.Instance
            .get('api/upcoming-holiday')
            .then((response) => {
                this.date = response.data.date;
                this.occasion = response.data.occasion;
            });
    }
}
